// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1lhqH","title":"ClientInsurance_title__IdqEn","itemText":"ClientInsurance_itemText__30ddF"};